import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { PagedResponse } from "../../types/Result";
import { SystemChat } from "../systemChat/type";

export const systemChatListLoader: LoaderFunction = async (args) => {
  let url = new URL(args.request.url);
  const result = await axiosApi.get<PagedResponse<SystemChat>>(
    url.search
      ? `/api/systemChats${url.search}`
      : "/api/systemChats?sort.field=creationTime&sort.sort=desc"
  );
  return result.data;
};
